(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mk-trust-tiles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mk-trust-tiles')) {
    customElements.define('mk-trust-tiles', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        const tiles = [...this.querySelectorAll('.mk-trust__tile')];
        const expanded = (tile, value) => tile.querySelector('button').setAttribute('aria-expanded', String(value));
        tiles.forEach(tile => {
          const button = tile.querySelector('button');
          tile.addEventListener('mouseenter', () => {
            if (!this.desktop.matches) return;
            tile.removeAttribute('data-dismissed');
            expanded(tile, true);
          });
          tile.addEventListener('mouseleave', () => {
            if (!this.desktop.matches) return;
            tile.removeAttribute('data-dismissed');
            expanded(tile, tile.contains(document.activeElement));
          });
          tile.addEventListener('focusin', () => {
            if (!this.desktop.matches) return;
            tile.removeAttribute('data-dismissed');
            expanded(tile, true);
          });
          tile.addEventListener('focusout', event => {
            if (this.desktop.matches && !tile.contains(event.relatedTarget)) expanded(tile, tile.matches(':hover'));
          });
          button.addEventListener('click', () => {
            if (this.desktop.matches) {
              tile.removeAttribute('data-dismissed');
              expanded(tile, true);
              return;
            }
            const opening = !tile.hasAttribute('data-open');
            tiles.forEach(other => {
              other.removeAttribute('data-open');
              expanded(other, false);
            });
            tile.toggleAttribute('data-open', opening);
            expanded(tile, opening);
          });
          tile.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            tile.setAttribute('data-dismissed', '');
            tile.removeAttribute('data-open');
            expanded(tile, false);
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
